import React, { useState } from "react";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import Loader from "../../components/common/Loader";
import { ArrowClockwise } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "react-bootstrap";
import Footer from "../../components/admin/footer/Footer";
import Ethernet from "./Ethernet";
import Vlan from "./Vlan";

const InterfaceMonitor = () => {
  const { t } = useTranslation();

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="component_name">{t("interfaceMonitor")}</div>

                  <div className="d-flex justify-content-center align-items-center">
                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          //   onClick={reloadHandler}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="collectorWrapper py-2 mt-2">
                  <Tabs>
                    <Tab eventKey="ethernet" title={t("ethernet")}>
                      <Ethernet />
                    </Tab>
                    <Tab eventKey="vlan" title={t("vlan")}>
                      <Vlan />
                    </Tab>
                  </Tabs>
                </div>
              </FourGround>

              <Footer />
            </FontColor>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterfaceMonitor;
